import { PlatformDevice } from '@/models/platformDevice';

export const CONFIG_STATUS_MAP = {
    Pending: { label: 'Update Pending', className: 'unknown' },
    Failed: { label: 'Update Failed', className: 'offline' },
    InSync: { label: 'No Update Pending', className: 'online' },
    NotAssigned: { label: 'Not Assigned', className: 'unknown' }
} as const;

export const FIRMWARE_STATUS_MAP = {
  Pending: { label: 'Update Pending', className: 'unknown' },
  Failed: { label: 'Update Failed', className: 'offline' },
  Healthy: { label: 'No Update Pending', className: 'online' },
  NotAssigned: { label: 'Not Assigned', className: 'unknown' }
} as const;

type ConfigurationStatus = keyof typeof CONFIG_STATUS_MAP;
type FirmwareStatus = keyof typeof FIRMWARE_STATUS_MAP;

interface PlatformDeviceTableRowProps {
  device: PlatformDevice
}

export default function PlatformDeviceTableRow({
  device,
}: PlatformDeviceTableRowProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString()
  }

  const configurationStatusKey = device.configurationStatus as ConfigurationStatus;
  const configurationStatus = CONFIG_STATUS_MAP[configurationStatusKey];

  const firmwareStatusKey = device.firmwareStatus as FirmwareStatus;
  const firmwareStatus = FIRMWARE_STATUS_MAP[firmwareStatusKey];
  
  return (
    <tr>
      <td>{device.serialNumber}</td>
      <td>{device.imei || '-'}</td>
      <td>{device.type || '-'}</td>
      <td>{device.partnerName || '-'}</td>
      <td>{device.phoneNumber || '-'}</td>
      <td>{device.simSerialNumber || '-'}</td>
      <td>{device.simProviderName || '-'}</td>
      <td>{device.firmware || '-'}</td>
      <td>{device.configurationName || '-'}</td>
      <td>{formatDate(device.dateAddedUtc)}</td>
      <td>
          <span className={`health-status ${configurationStatus.className}`}>
            {configurationStatus.label}
          </span>
      </td>
      <td>
        <span className={`health-status ${firmwareStatus.className}`}>
            {firmwareStatus.label}
        </span>
      </td>
    </tr>
  )
}